import React from "react";

const UserActionSidebar = ({ user }) => {
  const permissions = [
    { id: "dashboard", label: "Dashboard", checked: true },
    { id: "users", label: "Users", checked: true },
    { id: "roles", label: "Roles & Permissions" },
    { id: "accessHistory", label: "Access History", checked: true },
    { id: "media", label: "Media" },
    { id: "marketing", label: "Marketing" },
    { id: "server", label: "Server", checked: true },
    { id: "branding", label: "Branding" },
    { id: "activityLogs", label: "Activity Logs" },
    { id: "failedLogin", label: "Failed Login Attempts" },
    { id: "systemUpdates", label: "System Updates", checked: true }
  ];

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="userActionSidebar"
    >
      {/* Header */}
      <div className="offcanvas-header">
        <h5 className="offcanvas-title"><strong>Add Permission</strong></h5>
      </div>

      {/* Body */}
      <div className="offcanvas-body d-flex flex-column">
        <form className="row g-2 flex-grow-1">

          {/* User Info */}
          <div className="col-6">
            <strong>Name:</strong> {user?.name}
          </div>

          <div className="col-6">
            <strong>Role:</strong> {user?.role}
          </div>

          <hr />

          <div className="col-12">
            <h6>Permissions</h6>
          </div>

          {permissions.map((item) => (
            <div className="col-6" key={item.id}>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={item.id}
                  defaultChecked={item.checked}
                />
                <label className="form-check-label" htmlFor={item.id}>
                  {item.label}
                </label>
              </div>
            </div>
          ))}
          
        </form>

        {/* Buttons */}
        <div className="mt-auto pt-3 border-top">
          <div className="d-flex justify-content-end gap-2">

            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="offcanvas"
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => console.log("Save changes")}
            >
              Save Changes
            </button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UserActionSidebar;